import Proj1 from "../assets/proj1.jpg";
import Proj2 from "../assets/proj2.jpg";
import Proj3 from "../assets/proj3.webp";
import Proj4 from "../assets/proj4.webp";
import Proj5 from "../assets/proj5.jpg";
import Proj6 from "../assets/proj6.png";

export const ProjectList = [
  // {
  //   name: "Dijkstra Algorithm Visualizer",
  //   image: Proj1,
  //   skills: "JavaScript,HTML,CSS",
  // },
  {
    name: "Ecommerce Website",
    image: Proj2,
    skills: "React,Rest API",
    link: "https://dealson.netlify.app/"
  },
  {
    name: "Movie Information Website",
    image: Proj3,
    skills: "React,API,Bootstrap",
    link:"https://sauravmovies.netlify.app/"
  },
  {
    name: "Portfolio Website",
    image: Proj4,
    skills: "React,Bootstrap",
    link:"https://sauravportfolio.netlify.app/"
  },
  {
    name: "ERP System",
    image: Proj5,
    skills: "JavaScript,HTML,CSS,Bootstrap,PHP,MySQL",
  },
  // {
  //   name: "Mobile Game",
  //   image: Proj6,
  //   skills: "React Native,JavaScript,HTML,CSS",
  // },
];
